/**
 * Flexrix Sportsbook'un hazır renk şemaları ve SSO imza algoritmaları.
 *
 * Kümeler backend'deki `services/flexrix.py` (`THEMES` / `JWT_ALGORITHMS`)
 * ile **aynı kalmalıdır**: sağlayıcı tanımadığı temayı reddeder ve backend
 * liste dışı değeri 400 ile geri çevirir. Panelde görünüp uygulanamayan bir
 * seçenek "seçtiğim tema kaydedilmiyor" şikâyetinden başka iz bırakmaz.
 */
export const FLEXRIX_THEMES = [
  { value: 'flexrix-red', label: 'Flexrix Kırmızı' },
  { value: 'royal-blue', label: 'Royal Mavi' },
  { value: 'emerald-dark', label: 'Zümrüt · Koyu' },
  { value: 'gold-black', label: 'Altın · Siyah' },
  { value: 'purple-velvet', label: 'Mor Kadife' },
  { value: 'light-blue', label: 'Açık Mavi' },
  { value: 'light-crimson', label: 'Açık Kırmızı' },
  { value: 'light-black', label: 'Açık Siyah' },
  { value: 'champagne-gold', label: 'Şampanya Altın' },
  { value: 'forest-green', label: 'Orman Yeşili' },
  { value: 'electric-lime', label: 'Elektrik Yeşili' },
  { value: 'azure-light', label: 'Azur · Açık' },
  { value: 'carbon-silver', label: 'Karbon Gümüş' },
  { value: 'synthwave', label: 'Synthwave' },
  { value: 'sunset-orange', label: 'Gün Batımı Turuncu' },
  { value: 'mint-light', label: 'Nane · Açık' },
  { value: 'rose-gold', label: 'Rose Gold' },
  { value: 'midnight-cyan', label: 'Gece Mavisi' },
  { value: 'navy-amber', label: 'Lacivert · Kehribar' },
  { value: 'olive-tactical', label: 'Haki' },
  { value: 'blood-orange', label: 'Kan Portakalı' },
  { value: 'amber-graphite', label: 'Kehribar · Grafit' },
  { value: 'monochrome-dark', label: 'Tek Renk · Koyu' },
];

// EdDSA (Ed25519) sağlayıcının önerdiği algoritmadır; RS256 eski kurulumlar
// için durur. Algoritma değişince anahtar çifti yeniden üretilmelidir.
export const FLEXRIX_JWT_ALGORITHMS = [
  { value: 'EdDSA', label: 'EdDSA (Ed25519) — önerilen' },
  { value: 'RS256', label: 'RS256 (RSA 2048)' },
];

export default FLEXRIX_THEMES;
